import React from "react";
import "../css/Split_AC_Repair.css";
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";

export default function Split_AC_Repair() {
  return (
    <>
    <Topbar/>
          <Header />
      {/* Hero (your original card) */}
      <section className="ac-hero">
        <div className="ac-hero-bg" />

        <div className="ac-hero-card">
          <p className="ac-hero-kicker">Expert Split AC Repair and Service</p>

          <h1 className="ac-hero-title">
           Keeping You Cool All Year
            <br />
          Round
          </h1>

          <p className="ac-hero-subtitle">
         Get Split AC repair and service at your doorstep in 30 minutes. Schedule your service now!
          </p>

          <a className="ac-hero-cta" href="tel:7237898275">
            7237898275
          </a>
        </div>
      </section>

        {/* === New content section: two-column layout like screenshots === */}
      <section className="ac-article-section">
        <div className="container ac-article-grid">
          <div className="ac-article-text">
            <h2 className="ac-article-heading">Your Trusted Split AC Repair and Service Experts</h2>

            <p>When the sweltering heat of summer arrives, ensuring that your air conditioning system is in top shape becomes essential At<a className="ac-link" href="#">Jay Ambe AC Service</a> we specialize in providing reliable <strong>split AC repair and service </strong>  to keep your home or office cool and comfortable all season long </p>

            <p>
            With years of experience in the industry, our skilled technicians are equipped to handle a wide range of issues related to split air conditioners. Whether your unit is not cooling effectively, making unusual noises, or simply requires routine maintenance, we have the expertise to diagnose and resolve any problem efficiently. Our commitment to customer satisfaction means that we prioritize quick response times without compromising on quality.           
             </p>

         
            <p>
      At Jay Ambe AC Service, customer satisfaction is our top priority. We tailor our services according to your specific needs and provide flexible scheduling options to accommodate your busy lifestyle. Our transparent pricing ensures that there are no hidden fees or surprises when it comes time for payment.
            </p>

            <p>
          At Jay Ambe AC Service, we understand that a malfunctioning air conditioner can disrupt your daily life. That’s why we offer flexible scheduling options tailored to meet your needs. Our team arrives promptly at your location with all the necessary tools and parts required for repairs or servicing—ensuring minimal downtime for you.
            </p>

            <p>
              Regular maintenance is key to extending the lifespan of your split AC unit. Our comprehensive service packages include cleaning filters, checking refrigerant levels, inspecting electrical components, and more—all designed to enhance performance and energy efficiency while reducing the likelihood of future breakdowns.
            </p>
            <p>We take pride in delivering transparent pricing with no hidden fees so you can rest easy knowing exactly what you’re paying for. Trust Jay AMbe AC Service for exceptional workmanship backed by a guarantee of quality.</p>
            <p>Stay cool this summer! Contact us today for expert split AC repair and service solutions tailored just for you! Let Jay Ambe AC Service help you beat the heat with confidence!</p>

          </div>

          <div className="ac-article-image-wrap">
            <img
              className="ac-article-image"
              src={require("../assets/split-ac-service.jpg")}
              alt="AC service"
            />
          </div>
        </div>
      </section>
   <Herolast  />
      <Footer  />
     
    </>
  );
}
